import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/.pnpm/next@15.1.9_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
